import { shop } from '@/commonTypes';
import React from 'react';
import styles from '../styles.module.css';
import ShopCommitments from '../ShopCommitments';
import ShopWorkingHours from '../ShopWorkingHours';

export default function ShopAboutSection({ shop }: { shop?: shop }) {
  return (
    <>
      <div className={`card ${styles.card}`}>
        <h2 className={`${styles.shopTitle}`}>درباره {shop?.title}</h2>
        <p className={`${styles.shopDescription}`}>{shop?.description}</p>
      </div>
      <div className={`card ${styles.card}`}>
        <ShopCommitments />
      </div>
      <div className={`card ${styles.card}`}>
        <ShopWorkingHours />
      </div>
    </>
  );
}
